import axios from 'axios';
import xpcConfig from '../../config';
import xpcLocaleMessage from '../../locale';

const getMessage = localeid => {
  return new Promise((resolve, reject) => {
    let { localesMessageUrl, localeGroup, defaultAppKey } = xpcConfig.get();

    const globalKey = `__RT_LOCALE_${localeGroup}_${localeid}__`;

    if (window[globalKey]) {
      resolve(window[globalKey]);
    } else {
      rt.get(localesMessageUrl + localeid + '&appKey=' + defaultAppKey)
        .then(res => {
          window[globalKey] = res.LanguageConfigs;
          resolve(res.LanguageConfigs);
        })
        .catch(() => {
          reject(new Error('get messages error'));
        });
    }
  });
};

const getLocales = () => {
  return new Promise((resolve, reject) => {
    let { localesUrl } = xpcConfig.get();
    rt.get(localesUrl)
      .then(res => {
        let locales = res.map(item => {
          return {
            value: item.new_code,
            name: item.new_displayname,
            native: item.new_name,
            langid: item.new_langid
          };
        });
        resolve(locales);
      })
      .catch(() => {
        reject(new Error('get locales error'));
      });
  });
};

const use = (Vue, i18n) => {
  let {
    defaultLocale,
    defaultLocaleStorageKey,
    defaultLocaleId,
    defaultLocaleIdStorageKey
  } = xpcConfig.get();

  // localStorage 是否有用户设置的语种，有使用用户设置，没有使用默认设置；
  let locale = localStorage[defaultLocaleStorageKey] || defaultLocale;
  let localeid = localStorage[defaultLocaleIdStorageKey] || defaultLocaleId;

  // 获取所有支持语种，并缓存到 localStorage
  getLocales().then(res => {
    // 放置到 store 对象
    localStorage.setItem('locales', JSON.stringify(res));
  });

  // 根据默认语种 id 获取语言包；
  const message = getMessage(localeid);
  message.then(res => {
    i18n.locale = locale;
    i18n.setLocaleMessage(locale, res);
  });

  // 设置请求头语言，通知后端
  axios.interceptors.request.use(function (_config) {
    _config.headers['Accept-Language'] = locale;
    return _config;
  });
};

export default {
  name: 'localePlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, opts) {
    const { i18n } = opts;

    const {
      defaultLocale,
      defaultLocaleStorageKey,
      defaultLocaleId,
      defaultLocaleIdStorageKey,
      elementLocaleMessage
    } = xpcConfig.get();

    // 初始化多语言时，需要将当前默认语言保存到localStorage中
    localStorage.setItem(defaultLocaleStorageKey, defaultLocale);
    localStorage.setItem(defaultLocaleIdStorageKey, defaultLocaleId);

    if (i18n) {
      i18n.locale = defaultLocale;

      if (i18n.setLocaleMessage) {
        const originFn = i18n.setLocaleMessage;

        i18n.setLocaleMessage = function (_locale, _message) {
          const self = this;

          originFn.call(self, _locale, {
            ...elementLocaleMessage[_locale],
            ...xpcLocaleMessage[_locale],
            ..._message
          });
        };
      }

      if (i18n.messages && Object.keys(i18n.messages).length === 0) {
        i18n.setLocaleMessage(defaultLocale, {});
      }
    }

    const tx = (defaultValue, key, params) => {
      // 没有传入 key ，直接返回 defaultValue
      if (!key) return defaultValue;
      // i18n 方法存在，使用 i18nMethod 翻译
      if (i18n && i18n.t) {
        let value = i18n.t(key, params);
        if (value === key) return defaultValue;
        return value !== undefined ? value : defaultValue;
      }
      return defaultValue;
    };

    Vue.prototype.$tx = tx;

    Vue.prototype.$_t = (key, defaultValue, params) => {
      return tx(defaultValue, key, params);
    };

    // 存在多语言实例，根据配置获取多语言包和语种并缓存
    if (i18n) {
      use(Vue, i18n);
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/locale/index.js